"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Wow;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Wow(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Emojis",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#231f20;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "icon"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "wow"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M52.971,7.6A42.5,42.5,0,0,0,47.029,92.4c1.008.071,2,.105,3,.105A42.5,42.5,0,0,0,52.971,7.6ZM87.409,52.621A37.5,37.5,0,1,1,49.974,12.5q1.316,0,2.647.093A37.543,37.543,0,0,1,87.409,52.621Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M50.618,47.427c-6.49,0-11.77,6.374-11.77,14.208s5.28,14.209,11.77,14.209,11.77-6.374,11.77-14.209S57.108,47.427,50.618,47.427Zm0,23.417c-3.733,0-6.77-4.131-6.77-9.209s3.037-9.208,6.77-9.208,6.77,4.131,6.77,9.208S54.351,70.844,50.618,70.844Z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    className: "cls-1",
    cx: "36.434",
    cy: "38.384",
    r: 5
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M37.309,25.921a2.5,2.5,0,0,0-2.756-2.215c-9.219,1-11.8,8.419-11.876,12.2a2.492,2.492,0,0,0,2.429,2.54h.071a2.508,2.508,0,0,0,2.5-2.421c.024-.671.437-6.588,7.42-7.348A2.5,2.5,0,0,0,37.309,25.921Z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    className: "cls-1",
    cx: "63.934",
    cy: "38.384",
    r: 5
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M65.815,23.706a2.5,2.5,0,0,0-.542,4.971c6.974.76,7.394,6.66,7.419,7.345a2.5,2.5,0,0,0,2.5,2.434h.052a2.5,2.5,0,0,0,2.449-2.55C77.615,32.125,75.034,24.711,65.815,23.706Z"
  }))));
}